import React, { memo } from "react"
import httpclient from "libs/Axios";
import History from "core/utils/history";
import styled from 'styled-components';
import { error } from "core/components/Notify";
import { useFetchBranchDetails } from "features/BranchSetup/hooks/useFetchBranchDetails";
import { Button } from "core/components/Button";
import { useAuthenticationSlice } from "features/Authentication/slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "controller/types";

interface Props { }

const FinishSetup = memo((props: Props) => {
  const [branchDetails, setBranchDetails] = React.useState<any>({});
  useFetchBranchDetails(branchDetails, setBranchDetails, true);
  const { actions } = useAuthenticationSlice();
  const state = useSelector((state: RootState) => state.authentication);
  const dispatch = useDispatch();

  const [saving, setSaving] = React.useState(false);

  // upsert replaces the whole branch, so it requires every mandatory field. The
  // details load in the background as this step mounts
  const isReady = Boolean(branchDetails?.BRANCH_ID);

  const onSubmit = async () => {
    if (!isReady || saving) return;

    setSaving(true);
    const { STATUS, ...rest } = branchDetails;
    try {
      const response = await httpclient().post(`/data/branch/upsert`, [{
        ...rest,
        // CONVENIENCE_FEE_TYPE: branchDetails?.CONVENIENCE_FEE_TYPE === null ? '' : branchDetails?.CONVENIENCE_FEE_TYPE,
        BRANCH_SETUP: 'COMPLETED'
      }]);
      if (response?.data?.code === 201 || response?.data?.code === 200) {
        dispatch(actions.updateAuthData({
          ...state?.authData,
          BRANCH_SETUP: 'COMPLETED',
          ALLOW_INITIAL_SETUP_ACCESS: false
        }));
        History.navigate('/dashboard');
        // setTimeout(() => {
        //   window.location.href = '/dashboard';
        // }, 100);
        return;
      }
    } catch (err: any) {
      error(err?.message, true);
    }
    setSaving(false);
  };

  return (
    <div className="h-[60vh] flex justify-center items-center">
      <SuccessButton onClick={onSubmit} disabled={!isReady || saving}>
        {!isReady
          ? 'Loading branch details…'
          : saving ? 'Finishing…' : 'Enter Dashboard'}
      </SuccessButton>
    </div>
  )

})

export default FinishSetup;

const SuccessButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  background-color: #28a745; /* Success color */
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #218838; /* Darker shade of success color on hover */
  }

  &:disabled {
    background-color: #94d3a2;
    cursor: not-allowed;
  }

  &:disabled:hover {
    background-color: #94d3a2;
  }
`;